export enum FeedbackState {
  New = "New",
  Approved = "Approved",
  InDevelopment = "InDevelopment",
  Completed = "Completed",
  Declined = "Declined",
  CannotReproduce = "CannotReproduce",
  NotApplicable = "NotApplicable",
  PendingReview = "PendingReview",
  ReadyForDev = "ReadyForDev",
  Confirmed = "Confirmed"
}
export enum FeedbackCategory {
  FeatureRequest = "FeatureRequest",
  BugReport = "BugReport",
  ResourceRequest = "ResourceRequest"
}
export enum FeedbackVote {
  Up = "Up",
  Down = "Down",
  None = "None"
}
export enum FeedbackSortOption {
  Title = "Title",
  DateCreated = "Date Created",
  Trending = "Trending",
  Comments = "Comments",
  Priority = "Priority"
}

export enum FeedbackParent {
  Application = "Application",
  // Tool = "Tool",
  Topic = "Topic"
}

export enum FeedbackPriority {
  VeryLow = 1,
  Low = 2,
  Medium = 3,
  High = 4,
  VeryHigh = 5
}

export enum FeedbackEditType {
  Normal = "Normal",
  Move = "Move"
}

export enum FeedbackSize {
  Small = "Small",
  Medium = "Medium",
  Large = "Large"
}
